.container {
  width: 100%;
  margin-bottom: 2.4rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;

  &:not(:first-child) {
    margin-top: 5.6rem;
  }
}

.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #31343c;
  padding-bottom: 0.8rem;
  align-items: center;
  user-select: none;
}

.title-container {
  display: flex;
  gap: 0.8rem;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-style: normal;
  line-height: 4rem;
  color: #e6edf3;
}

.description {
  line-height: 2.4rem;
  color: var(--color-grayscale-light-slate);
  max-width: 60rem;
  overflow-wrap: break-word;

  a {
    color: white;
    text-decoration: underline;
  }
}

.actions {
  display: flex;
}
